const styles = {
  card: {
    flex: 1,
    textAlign: 'center',
  },
  group: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  fab: {
    position: 'absolute',
    bottom: 20,
    right: 20,
  },
};

export default styles;
